<template>
  <div class="topic-detail">
    <div v-wechat-title="$route.meta.title=docTitle"></div>
    <div v-if="talkDetail">
      <div class="topic-detail-top">
        <div class="topic-detail-top-avatarUrl">
          <img :src="talkDetail.member.avatarUrl" class="avatarUrl"  v-load="'oPicXS'" v-if="talkDetail.member.avatarUrl"/>
          <img src="@/assets/img/empty.png" class="avatarUrl" v-else/>
          <div>
            <span class="span1">
              {{talkDetail.member.name || talkDetail.member.nickName}}
              <span style="color: #666;font-size: .2rem;padding-left:.12rem;line-height:.26rem;font-weight: normal;">
                {{talkDetail.member.jobTitle}}
              </span>
            </span>
            <span class="span2">{{talkDetail.member.company}} </span>
          </div>
        </div>
        <p>{{talkDetail.content}}</p>
        <div class="topic-detail-top-img" v-if="talkDetail.imgUrls">
          <template v-for="(img,index) in talkDetail.imgUrls.split(';')">
              <img :src="img"  :key="index"  preview="1" :large="img"  v-load="'oPic'"  />
          </template>
        </div>

        <div class="topic-detail-top-tips">
          <span v-for="(themes,index2) in talkDetail.themes" :key="index2" @click="LinkToHotDetails(themes.id)"> #{{themes.title}}#</span>
        </div>
        <div class="topic-detail-top-read">
          <span class="number">{{talkDetail.viewCount}}</span>
          <span class="text">浏览</span>
          <span class="number">{{talkDetail.commentCount}}</span>
          <span class="text">评论</span>
          <span class="number">{{talkDetail.likeCount}}</span>
          <span class="text">点赞</span>
          <span class="time"> {{talkDetail.createAt}}</span>
        </div>
      </div>
      <!--评论列表-->
      <div style="padding-bottom: 1.1rem" v-if="dataList.length">
        <div
          class="topic-detail-list"
          v-for="(item2,index2) in dataList"
          :key="index2"
          @click="reply(item2.id)"
        >
          <div class="topic-detail-top-avatarUrl">
            <img  :src="item2.member.avatarUrl"  v-load="'oPicXS'" class="avatarUrl" v-if="item2.member.avatarUrl"/>
            <img src="@/assets/img/empty.png" class="avatarUrl" v-else />
            <div>
              <div style="display: flex;justify-content: space-between">
                <span class="span1">  
                  {{item2.member.name || item2.member.nickName}}
                  <span style="color: #666;font-size: .2rem;padding-left:.12rem;line-height:.26rem;font-weight:normal;">
                     {{ item2.member.jobTitle}}
                  </span>
                </span>
                <span class="span3"> {{item2.createAt}}</span>
              </div>
              <span class="span2"> {{item2.member.company}}</span>
            </div>
          </div>
          <p> {{item2.content}}</p>
          <div class="reply">
            <div class="reply-list" v-for="(item,index) in item2.childrens" :key="index">
              <span class="reply-span1">{{item.member.name}}</span>
              <span class="reply-span2">：{{item.content}}</span>
            </div>
          </div>
        </div>
      </div>
       
      <div class="topic-detail-bottom">
        <div class="topic-detail-bottom-input">
          <input
            type="text"
            placeholder="说说您的看法吧~"
            v-model="demandcomment"
            maxlength="500"
            @keyup.13="Submitdemandcomment"
            @focus='inputFocus'
            ref="input"
          />
          <!-- autofocus="autofocus" -->
        </div>
        <div class="topic-detail-bottom-zan" @click="talkLike()">
            <i class="icon iconfont icon-dianzan dianzan" v-if="talkDetail.isLike" style="color:#ff4b2b;"></i>
            <i class="icon iconfont icon-dianzan dianzan" v-else></i>
            <span  v-if="talkDetail.isLike">点赞</span>
            <span style="color:#666;" v-else>点赞</span>
        </div>
        <div class="topic-detail-bottom-share" @click="$refs.shareModel.open()">
          <i class="icon iconfont icon-fenxiang2 fenxiang"></i>
          <span>分享</span>
        </div>
      </div>
    </div>

    <shareModel ref="shareModel"></shareModel>

  </div>

</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import shareModel from "@/components/shareModel";
import {Dialog, ImagePreview} from 'vant';
import gql from 'graphql-tag';
export default {
  data() {
    return {
      showBg: true,
      searchtext: "",
      topicId: "",
      talkDetail: "",
      talkList: [], //讨论的评论列表，
      demandcomment: "",
      addLike: false, //是否点赞，
      isFocus: false, //是否聚焦
      keyHeight: 0,
      inputShowed: false,
      talkDemandId: "",
      showHint:false,

      isMy:false, // 是否为二级评论
      loading: false, //展商加载状态
      finished: false, //加载是否完成状态
      dataList: [], //供需列表
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      totalPages: 0,
      queryTalkComment:"",
      docTitle:'讨论详情'
    };
  },
  components: {
    shareModel
  },

  computed: {
      ...mapGetters({
        statusBarHeight: "getStatusBarHeight",
        userInfo: "getUserInfo",
        oPotoView:'oPotoView'
      }),
    talkId() {
      return this.$route.query.talkId;
    },
    TalkGql(){
          return gql `query
                  talk($talkId: Guid!){
                      talk(talkId: $talkId){
                        commentCount
                        content
                        createAt
                        id
                        imgUrls
                        isLike(memberId:"${this.userInfo.id}")
                        likeCount
                        member{
                          avatarUrl
                          company
                          id
                          jobTitle
                          name
                          nickName
                          phone
                        }
                        memberId
                        orgin
                        shareCount
                        themes{
                          content
                          id
                          title
                        }
                        userCount
                        viewCount
                      }
                  }`
      },
      CommentListGql(){
          return gql `query
                  queryTalkComment($query: QueryInput!){
                      queryTalkComment(query: $query){
                          hasNextPage
                          hasPreviousPage
                          items{
                              childrens(num:10){
                                content
                                createAt
                                id
                                member{
                                  avatarUrl
                                  company
                                  jobTitle
                                  name
                                  nickName
                                  phone
                                  userId
                                }
                                memberId
                                parentId
                                replyCount
                                talkId
                                userInfo
                              }
                              content
                              createAt
                              id
                              member{
                                avatarUrl
                                company
                                jobTitle
                                name
                                nickName
                                phone
                                userId
                              }
                              memberId
                              parentId
                              replyCount
                              talkId
                              userInfo
                          }
                          pageIndex
                          pageSize
                          totalCount
                          totalPages
                      }
                  }`
      },
  },
  created() {
    this.init();
  },
  mounted(){
    //图片查看器打开后，打印本次查看器的实例（事件、方法、属性的示例）
    this.$preview.on("imageLoadComplete", (e, item) => {});
  },
  methods: {
    ...mapActions({
      // getTopicInfo: "topicSupply/getTopicInfo",
      // TalkComment: "topicSupply/TalkComment",
      // TalkDetail: "topicSupply/TalkDetail",
      // TalkLikeRemove: "topicSupply/TalkLikeRemove",
      // TalkShare: "topicSupply/TalkShare",
      // LinkAuerBach: "linkTo/LinkAuerBach",
      // LinkEditSecre: "linkTo/LinkEditSecre",


      LinkToHotDetails: "linkTo/LinkToHotDetails",
      TalkLike: "topicSupply/TalkLike",
      TalkView: "topicSupply/TalkView",
      TalkCommentcontent: "topicSupply/TalkCommentcontent",
      shareToWechat:'wxShare/shareToWechat',
      LinkToError:'linkTo/LinkToError',
    }),
    async init() {
      //增加浏览量
      let user = {
        avatarUrl: this.userInfo.avatarUrl,
        name: this.userInfo.name,
        company: this.userInfo.company,
      };
      let opt = {
        talkId: this.talkId,
        memberId: this.userInfo.id,
        userInfo: JSON.stringify(user),
        number: 1,
      };
      let data1 = await this.TalkView(opt);
      this.getTalk();
      this.getTalkList();
    },
    getTalk(){
      this.$apollo.addSmartQuery("talk",{
          query:this.TalkGql,
          variables:{
              talkId: this.talkId,
          },
          fetchPolicy:'network-only',  // 清除缓存的数据，重新获取服务器数据
          result(res){
              let data = JSON.parse(JSON.stringify(res));
              if(data&&data.data.talk){
                this.talkDetail = data.data.talk;
                this.docTitle = this.talkDetail.themes[0] ? this.talkDetail.themes[0].title : '讨论详情';
                // 分享的配置
                const opt = {
                    title:`给您分享了一条话题讨论`,
                    desc: this.talkDetail.content,
                    link: window.location.href,
                    imgUrl:this.talkDetail.imgUrls ? this.talkDetail.imgUrls.split(';')[0] : this.talkDetail.member.avatarUrl
                };
                this.shareToWechat(opt);
              } else {
                this.LinkToError();
              }
          },
          error(error) {
              console.error(error,'error错误处理')
          }
      })
    },
    // 获取讨论列表
    getTalkList(){
        let where = {
            "Equal":{
              "n":"talkId",
              "v":this.talkId
            },
            "Equal2":{
              "n":"parentId",
            },
        };
        let order = [
          {
              "n":"createAt",
              "v":0
          },
        ];
        this.$apollo.addSmartQuery("queryTalkComment",{
            query:this.CommentListGql,
            variables:{
              query:{
                page: this.pageIndex,
                size: this.pageSize,
                where:JSON.stringify(where),
                order:JSON.stringify(order),
              }
            },
            fetchPolicy:'network-only',  // 清除缓存的数据，重新获取服务器数据
            result(res){
                let data = JSON.parse(JSON.stringify(res));
                if(data&&data.data.queryTalkComment.items.length){
                    let currentList = data.data.queryTalkComment.items;
                    if(this.pageIndex == 1){
                        this.dataList = currentList;
                    } else {
                        this.dataList = [...this.dataList,...currentList]
                    }
                    this.loading = false;
                    if (!data.data.queryTalkComment.hasNextPage) {
                        this.finished = true;
                    }
                }
                console.log(this.dataList,'this.dataList------');
                this.$previewRefresh();
            },
            error(error) {
                console.error(error,'error错误处理')
            }
        })
    },
    reply(talkDemandId) {
      this.$refs.input.focus();
      this.talkDemandId = talkDemandId;
      this.isMy = true;
    },
    // 讨论点赞
    async talkLike() {
        if (!this.talkDetail.isLike) {
          let user = {
            avatarUrl: this.userInfo.avatarUrl,
            name: this.userInfo.name,
            jobTitle: this.userInfo.jobTitle,
          };
          let opt = {
            talkId: this.talkId,
            memberId: this.userInfo.id,
            userInfo: JSON.stringify(user),
          };
          let data = await this.TalkLike(opt);
          if (data.result) {
          this.$toast.success('点赞成功')
            this.talkDetail.likeCount = this.talkDetail.likeCount + 1;
            this.talkDetail.isLike = true;
          }
        } else {
          let opt1 = {
            talkId: this.talkId,
            memberId: this.userInfo.id,
          };
          let data1 = await this.TalkLikeRemove(opt1);
          if (data1.result) {
            this.$toast.success('取消成功')
            if (this.talkDetail.likeCount > 0) {
              this.talkDetail.likeCount = this.talkDetail.likeCount - 1;
            }
            this.talkDetail.isLike = false;
          }
        }
    },
    // 评论回复
    async Submitdemandcomment() {
      if(this.isMy){ // 二级回复
        let user = {
          avatarUrl: this.userInfo.avatarUrl,
          name: this.userInfo.name,
          company: this.userInfo.company,
        };
        let opt1 = {
          talkId: this.talkId,
          memberId: this.userInfo.id,
          userInfo: JSON.stringify(user),
          content: this.demandcomment,
          parentId:this.talkDemandId,
          replyCount: 1,
        };
        if (!this.demandcomment) {
          return;
        } else {
          let data = await this.TalkCommentcontent(opt1);
          if (data.result) {
            this.$toast.success('发表成功')
            this.getTalkList();
            this.demandcomment = "";
            this.talkDetail.commentCount = this.talkDetail.commentCount + 1;
            this.isMy = false;
          } else {
            this.$toast.fail('发表失败')
          }
        }
        this.isMy = false;
      } else { // 一级留言
        let user = {
          avatarUrl: this.userInfo.avatarUrl,
          name: this.userInfo.name,
          company: this.userInfo.company,
        };
        let opt1 = {
          talkId: this.talkId,
          memberId: this.userInfo.id,
          userInfo: JSON.stringify(user),
          content: this.demandcomment,
          replyCount: 1,
        };
        if (!this.demandcomment) {
          return;
        } else {
          let data = await this.TalkCommentcontent(opt1);
          if (data.result) {
            this.$toast.success('发表成功')
            this.getTalkList();
            this.demandcomment = "";
            this.talkDetail.commentCount = this.talkDetail.commentCount + 1;
            this.inputShowed = false;
          } else {
            this.$toast.fail('发表失败')
          }
        }
      }
      
    },
    inputFocus(){
      if (!this.userInfo.phone) {this.$refs.input.blur();this.$Myapollo.unverifiedDialog(this); return; }
    }
  },
  

};
</script>

<style scoped lang='scss'>
.topic-detail {
  .pb {
    padding-bottom: .68rem;
  }
  &-top {
    padding: .3rem .24rem;
    border-bottom: .2rem solid #f5f5f5;
    background-color: #fff;
    &-avatarUrl {
      display: flex;
      width: 100%;
      align-items: center;
    }
    &-img {
      display: flex;
      margin-top: .22rem;
      img {
        width: 1.1rem;
        height: 1.1rem;
        margin-right: .1rem;
        background: #333;
      }
    }
    &-tips {
      margin-top: .2rem;
      margin-bottom: -0.1rem;
      margin-right: -0.1rem;
      span {
        padding: .06rem .18rem;
        margin-bottom: 0.1rem;
        font-size: .22rem;
        color: #ff5500;
        background-color: #ffddcc;
        border-radius: .16rem;
        margin-right: .1rem;
        display: inline-block;
      }
    }
    &-read {
      margin-top: .3rem;
      position: relative;
      display: flex;
      align-items: center;
      .number {
        margin-right: 3px;
        display: inline-block;
        font-size: .22rem;
        color: #666;
      }
      .text {
        margin-right: .3rem;
        display: inline-block;
        font-size: .22rem;
        color: #666;
      }
      .time {
        font-size: .22rem;
        color: #666;
        position: absolute;
        right: 0;
      }
    }
  }
  &-list {
    padding: .3rem .24rem 0 .24rem;
    background-color: #fff;
    position: relative;
    border-bottom: 1px solid #f2f2f2;
  }

  .avatarUrl {
    width: .7rem;
    height: .7rem;
    border-radius: 50%;
    background-color: #1d2435;
    margin-right: .16rem;
  }

  .span1 {
    font-size: .26rem;
    font-weight: bold;
    color: #333;
    display: inline-block;
  }
  .span2 {
    font-size: .22rem;
    color: #666;
    display: block;
    margin-top: .05rem;
  }
  .span3 {
    color: #666;
    position: absolute;
    right:.24rem;
    font-size: .22rem
  }
  p {
    margin-top: .22rem ;
    font-size: .26rem;
    line-height: .4rem;
    color: #333;
  }

  .dianzan {
    display: inline-block;
    font-size: .3rem;
    transform: scale(2);
    margin-bottom: .08rem;
  }
  .fenxiang {
    display: inline-block;
    font-size: .34rem;
    transform: scale(2);
    padding-bottom: .06rem;
  }

  .topic-detail-bottom {
    position: fixed;
    bottom: 0;
    display: flex;
    align-items: center;
    height: 1rem;
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2);
    &-input {
      margin: .17rem .24rem;
      width: 4.9rem;
      height: .64rem;
      background-color: #f2f2f2;
      border-radius: .32rem;
      position: relative;
      display: flex;
      align-items: center;
      input {
        margin-left: .26rem;
        border: none;
        background-color: #f2f2f2;
        width: 90%;
      }
    }
    &-zan{
        text-align:center;
        margin:.18rem .3rem;
        color: #666;
        span{
            display: block;
            // background:linear-gradient(90deg, #ff416c 0%,#ff4b2b 100%);
            // -webkit-background-clip: text;
            // color: transparent;
            color: #ff4b2b;
            font-size:.22rem;
        }
    }
    &-share{
        text-align:center;
        margin:.2rem 0 .17rem .22rem;
        color: #666;
        span{
            display: block;
            color:#666;
            font-size:.22rem
        }
    }
  }
  .reply {
    background-color: #f7f7f7;
    border-radius: .1rem;
    margin-bottom: .3rem;
    &-list {
      padding:.1rem .2rem;
      .reply-span1 {
        color: #f85b0f;
        font-size: .26rem;
      }
      .reply-span2 {
        color: #333;
        font-size: .26rem;
      }
    }
  }
}
button {
  padding: 0;
  line-height: 1;
  background-color: #fff;
}
button:after {
  border: none;
}

.fenxiang1{
  margin-top: 1.54rem;
  margin-left: 1.64rem;
  img{
    width: 4.58rem;
    height: 2.43rem;
  }
}
.fenxiang2{
  margin-top: 1.23rem;
  img{
    width:2.6rem;
    height: 0.78rem;
    margin-left: 2.46rem
  }
}
//   /deep/ .dialog_unauth{
//     .van-popup{
//       border-radius: 10px;
//       width: 560px;
//       box-sizing: border-box;
//       // .van-dialog__header{
//       //   padding-top: 50px;
//       //   font-size: 36px;
//       //   font-weight: bold;
//       //   color: #333;
//       // }
//       .van-dialog__message{
//         font-size: 30px;
//         color: #666;
//         line-height: 50px;
//       }
//       .van-hairline--top{
//         &::after{
//           border-color:#d2d3d5;
//           border-top-width: 2px;
//         }
//       }
//       .van-dialog__footer{
//         .van-hairline--right{
//           &::after{
//             border-color: #d2d3d5;
//             border-right-width: 2px;

//           }
//         }
//         .van-dialog__button{
//           .dialog-index--van-dialog__confirm{
//             color: #f85b0f!important;
//           }
//         }
//       }
//     }
//   }
</style>

